module.exports = __webpack_public_path__ + "static/media/info_review_order.611fed97.png";